import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { COMPANY } from "@/data/site";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F4F1EB]/85 border-b border-[#D1C9B8]/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="brand-logo"
          className="font-serif text-2xl tracking-tight text-[#1C2C22] leading-none"
        >
          KS <span className="italic text-[#C27A62]">Infinity</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide link-underline ${
                  isActive ? "text-[#1C2C22]" : "text-[#5C665C] hover:text-[#1C2C22]"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          data-testid="cta-request-quote"
          className="hidden md:inline-flex items-center gap-2 bg-[#1C2C22] text-[#F4F1EB] px-5 py-3 text-xs uppercase tracking-[0.2em] btn-lift hover:bg-[#C27A62]"
        >
          Request Quote
          <span aria-hidden>→</span>
        </Link>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-[#1C2C22]"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden border-t border-[#D1C9B8] bg-[#F4F1EB]"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `font-serif text-3xl ${
                    isActive ? "text-[#1C2C22]" : "text-[#5C665C]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="cta-request-quote-mobile"
              className="mt-4 inline-flex items-center gap-2 bg-[#1C2C22] text-[#F4F1EB] px-5 py-3 text-xs uppercase tracking-[0.2em] w-fit"
            >
              Request Quote →
            </Link>
            <div className="pt-4 text-sm text-[#5C665C]">
              {COMPANY.contacts.map((c) => (
                <div key={c.raw}>{c.name} · {c.phone}</div>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
